import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sd-folder-fill",
  "use": "sd-folder-fill-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"sd-folder-fill\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M22 23c1 0 2-1 2-2V7H0v14c0 1 1 2 2 2h20zm-4-12H6v1h12v-1zm0 3H6v1h12v-1zm0 3H6v1h12v-1z\" /><path d=\"M0 3a2 2 0 012-2h8.586a1 1 0 01.707.293L13 3h9a2 2 0 012 2v2H0V3z\" fill-opacity=\".5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol